




































































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import { Inject } from 'vue-property-decorator';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Getter, Mutation } from 'vuex-class';
import { FORM101_DATA, FORM101_META_DATA, FORM_READ_ONLY_MODE, SET_FORM101_DATA } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { Utils } from '@/globals/Utils';
import { Form101MetaData } from '@/models/form/Form101MetaData.model';

@Component({})
export default class EmployeeDetails extends FeedbackComponent {

  @Inject() public $validator: any;

  @Mutation(SET_FORM101_DATA, StoreNamespace.FORM) public setForm101Data;

  @Getter(FORM101_META_DATA, StoreNamespace.FORM) public form101MetaData!: Form101MetaData;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;

  private birthDate: Date | number | null = null;
  private immigrateDate: Date | number | null = null;

  public created() {
    if (this.form101Data.birthDate) {
      this.birthDate = Utils.stringToDate('' + this.form101Data.birthDate);
    }
    if (this.form101Data.immigrationDate) {
      this.immigrateDate = Utils.stringToDate('' + this.form101Data.immigrationDate);
    }
    if (this.form101Data.pensioner) {
      this.form101Data.pensioner = true;
    }
  }

  public updateDate(date: Date, property: string) {
    this.updateForm101Data(date ? Utils.dateToString(date) : date, property);
  }

  public updateForm101Data(newVal: any, property: string) {
    this.setForm101Data({ ...this.form101Data, [property]: newVal });
  }

}
